<template>
  <div>
    <v-layout row wrap align-center>
      <v-flex xs12 sm3 md3>
        <v-text-field :label="$t('Exception-Code')" :rules="rules" @blur="codeControl()" :disabled="active"
          :placeholder="kodmesajı" append-icon="list_alt" @click:append="dialogac()" :tabindex="tabdeger"
          v-model="val.kod" hide-details="">
        </v-text-field>
      </v-flex>

      <v-flex pt-4 pr-2 xs12 sm9 md9>
        <v-layout row fill-height align-center>
        <span class="subheading grey--text"><div class="ellipsis"> {{val.isim}}&nbsp; </div> </span>


        </v-layout>
        <v-divider></v-divider>
      </v-flex>

    </v-layout>


    <v-dialog scrollable="" persistent v-model="dialog" max-width="400px">
      <v-card flat color="grey lighten-5">
        <v-toolbar size="120px" color="info">
          <v-toolbar-title class="white--text"> {{$t('Exception-Code')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-flex xs12 sm4 md6>
            <v-text-field flat="" solo v-model="searchsatilanbilet" :label="$t('Search')" append-icon="search"></v-text-field>
          </v-flex>
        </v-toolbar>
        <v-card-text>

          <v-layout row="" wrap="">


            <v-flex xs12 sm12 md12>
              <v-card flat class="white--text">
                <v-card-actions>
                  <v-layout row wrap>

                    <v-flex xs12 sm12 md12>
                      <v-data-table :headers="headersservis" :loading="progress" :search="searchsatilanbilet"
                        :items="items" hide-actions class="elevation-1">
                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                        <template slot="items" slot-scope="props">
                          <tr @click="kabul(props.item)" item>
                            <td class="text-xs-left">{{ props.item.kod }}</td>
                            <td class="text-xs-left">{{ props.item.isim }}</td>

                            <td class="justify-center layout px-0">
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>


                  </v-layout>
                </v-card-actions>
              </v-card>





            </v-flex>
          </v-layout>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="filtreiptal()">
          {{$t("cancel_button")}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import tarihcomp from '@/components/app/customcomp/tarihim.vue'
  import genelarama from "@/components/app/coper/comp/genelarama.vue";
  import tool from '../tools'
  import helpers from "@/components/app/customcomp/helpers.js"


  export default {
    props: ["value", "tabdeger", "active", "rules", "satici", "tip"],
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },


    beforeMount: beforeMount,
    components: {
      tarihcomp,
      genelarama
    },
    methods: {
      test() {
        this.$emit('odakkaybi', this.val)
      },

      filtreiptal() {

        this.secilencari = null
        this.dialog = false
      },
      Ara() {
        this.pnrkalemloading = true
        this.items = []
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));


        setTimeout(() => {
          tool.http_post(this, 'PNRAra', this.prm).then((response) => {
            this.items = response.body;
            this.pnrkalemloading = false

          }, (response) => {
            this.status = tool.responseToStatus(response);
            this.pnrkalemloading = false
          })
        }, 500)
      },
      dialogac: dialogac,
      kabul: kabul,
      codeControl: codeControl
    },
    data() {
      return {


        searchsatilanbilet: null,
        prm: {
          tip: 304,
          id: '',
          kod: '',
          aciklama: '',
        },
        headersservis: [{
            text: this.$t('Code'),
            value: 'kod'
          },
          {
            text: this.$t('Description'),
            value: 'isim',

          },

        ],
        kodmesajı: null,
        progress: false,
        items: [],
        aranacakkelime: null,
        secilendeger: null,
        dialog: false,

        text1: null,
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },

    watch: {
      secilendeger(val) {
        val && this.kayitgetir(val)
      },
      dialog(val2) {
        if (!val2) return
        requestAnimationFrame(() => {
          //  this.$refs.ara.focus()
        })
      }

    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },
  }

  function codeControl() {


    if (this.val.kod != null && this.val.kod != '') {

      var params = {
        tip: 304,
        id: '',
        kod: this.val.kod,
        aciklama: '',
      }

      tool.http_post(this, 'GenelTanitimAra', params).then((response) => {

        this.pnrkalemloading = false

        if (response.body[0].id != 0) {
          this.val = response.body[0]
          this.kodmesajı = null
        } else {
          this.kodmesajı = 'Hatalı kod'
          var boskayit = {
            id: null,
            intField: 0,
            isim: null,
            kod: null,
            tip: null
          }
          this.val = boskayit
        }

      }, (response) => {
        this.status = tool.responseToStatus(response);
        this.pnrkalemloading = false
      })
    } else {
      this.kodmesajı = null
        var boskayit = {
            id: null,
            intField: 0,
            isim: null,
            kod: null,
            tip: null
          }
          this.val = boskayit
    }
  }

  function kabul(m) {
    this.val = m
    this.dialog = false
  }

  function dialogac() {
    if (this.active != true) {
      this.dialog = true
    }
    tool.http_post(this, 'GenelTanitimAra', this.prm).then((response) => {
      this.items = response.body;
      this.pnrkalemloading = false

    }, (response) => {
      this.status = tool.responseToStatus(response);
      this.pnrkalemloading = false
    })

  }

  function beforeMount() {
  }

</script>

<style>
.ellipsis{
  overflow:hidden; /* Verilen genişlikten (150px) artanı gizlemesini istiyoruz */
  white-space: nowrap; /* Yazıyı tek satırla sınırlandırıyoruz */
  text-overflow:ellipsis; /* Yazının kesildiği yerden üç nokta vermesini sağlıyoruz*/
  width: 420px;
}

</style>